export const FLIGHT_PRODUCTS_REQUEST = 'FLIGHT_PRODUCTS_REQUEST';
export const FLIGHT_PRODUCTS_SUCCESS = 'FLIGHT_PRODUCTS_SUCESS';
export const FLIGHT_PRODUCTS_ERROR = 'FLIGHT_PRODUCTS_ERROR';
